import { AccountType, CustomerRole, ResidentialType } from './_.dto'
import { AccountInfoDto, ProfileDto } from './account.dto'
import { BookingDto } from './booking.dto'
import { PaymentTerm } from './invoice.dto'

export enum COUNTRY_CODE {
  _65 = '+65',
  _86 = '+86',
  _60 = '+60',
  _62 = '+62',
  _84 = '+84',
  _7_840 = '+7 840',
  _93 = '+93',
  _355 = '+355',
  _213 = '+213',
  _1_684 = '+1 684',
  _376 = '+376',
  _244 = '+244',
  _1_264 = '+1 264',
  _1_268 = '+1 268',
  _54 = '+54',
  _374 = '+374',
  _297 = '+297',
  _247 = '+247',
  _61 = '+61',
  _672 = '+672',
  _43 = '+43',
  _994 = '+994',
  _1_242 = '+1 242',
  _973 = '+973',
  _880 = '+880',
  _1_246 = '+1 246',
  _375 = '+375',
  _32 = '+32',
  _501 = '+501',
  _229 = '+229',
  _1_441 = '+1 441',
  _975 = '+975',
  _591 = '+591',
  _387 = '+387',
  _267 = '+267',
  _55 = '+55',
  _1_284 = '+1 284',
  _673 = '+673',
  _359 = '+359',
  _226 = '+226',
  _257 = '+257',
  _855 = '+855',
  _237 = '+237',
  _1 = '+1',
  _238 = '+238',
  _345 = '+ 345',
  _236 = '+236',
  _235 = '+235',
  _56 = '+56',
  _57 = '+57',
  _269 = '+269',
  _242 = '+242',
  _243 = '+243',
  _682 = '+682',
  _506 = '+506',
  _385 = '+385',
  _53 = '+53',
  _599 = '+599',
  _537 = '+537',
  _420 = '+420',
  _45 = '+45',
  _253 = '+253',
  _1_767 = '+1 767',
  _1_809 = '+1 809',
  _670 = '+670',
  _593 = '+593',
  _20 = '+20',
  _503 = '+503',
  _240 = '+240',
  _291 = '+291',
  _372 = '+372',
  _251 = '+251',
  _500 = '+500',
  _298 = '+298',
  _679 = '+679',
  _358 = '+358',
  _33 = '+33',
  _596 = '+596',
  _594 = '+594',
  _689 = '+689',
  _241 = '+241',
  _220 = '+220',
  _995 = '+995',
  _49 = '+49',
  _233 = '+233',
  _350 = '+350',
  _30 = '+30',
  _299 = '+299',
  _1_473 = '+1 473',
  _590 = '+590',
  _1_671 = '+1 671',
  _502 = '+502',
  _224 = '+224',
  _245 = '+245',
  _595 = '+595',
  _509 = '+509',
  _504 = '+504',
  _852 = '+852',
  _36 = '+36',
  _354 = '+354',
  _91 = '+91',
  _98 = '+98',
  _964 = '+964',
  _353 = '+353',
  _972 = '+972',
  _39 = '+39',
  _225 = '+225',
  _1_876 = '+1 876',
  _81 = '+81',
  _962 = '+962',
  _7_7 = '+7 7',
  _254 = '+254',
  _686 = '+686',
  _965 = '+965',
  _996 = '+996',
  _856 = '+856',
  _371 = '+371',
  _961 = '+961',
  _266 = '+266',
  _231 = '+231',
  _218 = '+218',
  _423 = '+423',
  _370 = '+370',
  _352 = '+352',
  _853 = '+853',
  _389 = '+389',
  _261 = '+261',
  _265 = '+265',
  _960 = '+960',
  _223 = '+223',
  _356 = '+356',
  _692 = '+692',
  _222 = '+222',
  _230 = '+230',
  _262 = '+262',
  _52 = '+52',
  _691 = '+691',
  _1_808 = '+1 808',
  _373 = '+373',
  _377 = '+377',
  _976 = '+976',
  _382 = '+382',
  _1664 = '+1664',
  _212 = '+212',
  _95 = '+95',
  _264 = '+264',
  _674 = '+674',
  _977 = '+977',
  _31 = '+31',
  _1_869 = '+1 869',
  _687 = '+687',
  _64 = '+64',
  _505 = '+505',
  _227 = '+227',
  _234 = '+234',
  _683 = '+683',
  _850 = '+850',
  _1_670 = '+1 670',
  _47 = '+47',
  _968 = '+968',
  _92 = '+92',
  _680 = '+680',
  _970 = '+970',
  _507 = '+507',
  _675 = '+675',
  _51 = '+51',
  _63 = '+63',
  _48 = '+48',
  _351 = '+351',
  _1_787 = '+1 787',
  _974 = '+974',
  _40 = '+40',
  _7 = '+7',
  _250 = '+250',
  _685 = '+685',
  _378 = '+378',
  _966 = '+966',
  _221 = '+221',
  _381 = '+381',
  _248 = '+248',
  _232 = '+232',
  _421 = '+421',
  _386 = '+386',
  _677 = '+677',
  _27 = '+27',
  _82 = '+82',
  _34 = '+34',
  _94 = '+94',
  _249 = '+249',
  _597 = '+597',
  _268 = '+268',
  _46 = '+46',
  _41 = '+41',
  _963 = '+963',
  _886 = '+886',
  _992 = '+992',
  _255 = '+255',
  _66 = '+66',
  _228 = '+228',
  _690 = '+690',
  _676 = '+676',
  _1_868 = '+1 868',
  _216 = '+216',
  _90 = '+90',
  _993 = '+993',
  _1_649 = '+1 649',
  _688 = '+688',
  _1_340 = '+1 340',
  _256 = '+256',
  _380 = '+380',
  _971 = '+971',
  _44 = '+44',
  _598 = '+598',
  _998 = '+998',
  _678 = '+678',
  _58 = '+58',
  _681 = '+681',
  _967 = '+967',
  _260 = '+260',
  _263 = '+263'
}

export interface NewCustomerRequestBodyDto {
  email?: string
  password: string
  name: string
  contact: string
  countryCode?: string
  avatarId?: string
  avatarIsTemporary?: boolean
  customerRole: CustomerRole
  organizationName?: string
  remark?: string
  paymentTerm?: PaymentTerm
  paymentTermValue?: number
  designatedAddressLine1?: string
  designatedAddressLine2?: string
  designatedAddressPostalCode?: string
  designatedAddressCity?: string
  designatedAddressCountry?: string
  designatedResidentialType?: ResidentialType

  billingAddressLine1?: string
  billingAddressLine2?: string
  billingAddressPostalCode?: string
  billingAddressCity?: string
  billingAddressCountry?: string
  billingResidentialType?: ResidentialType

  isSameDesignatedAddress?: boolean
  subContacts?: CustomerSubContact[]
}

export interface UpdateCustomerRequestBodyDto {
  name: string
  email?: string
  contact: string
  countryCode?: string
  avatarId?: string
  avatarIsTemporary?: boolean

  customerRole: CustomerRole
  organizationName?: string
  paymentTerm?: PaymentTerm
  paymentTermValue?: number

  remark?: string

  designatedAddressLine1?: string
  designatedAddressLine2?: string
  designatedAddressPostalCode?: string
  designatedAddressCity?: string
  designatedAddressCountry?: string
  designatedResidentialType?: ResidentialType

  billingAddressLine1?: string
  billingAddressLine2?: string
  billingAddressPostalCode?: string
  billingAddressCity?: string
  billingAddressCountry?: string
  billingResidentialType?: ResidentialType

  isSameDesignatedAddress?: boolean
  subContacts?: CustomerSubContact[]
  isBlackList: boolean
}

export enum AddressType {
  Designated = 'DESIGNATED',
  Billing = 'BILLING'
}

export const AddressTypeLabel = {
  [AddressType.Designated]: 'Designated',
  [AddressType.Billing]: 'Billing'
}

export interface CustomerAddressDto {
  accountId: string
  addressName?: string
  addressLine1: string
  addressLine2: string
  addressPostalCode: string
  addressCity: string
  addressCountry: string
  residentialType?: ResidentialType
  isPrimary?: boolean
  id?: string
  addressType?: AddressType
  lat: number
  lng: number
  unitNo?: string
}

export interface TempCustomerAddressDto {
  addressName: string
  addressLine1: string
  addressLine2: string
  addressPostalCode: string
  addressCity?: string
  addressCountry?: string
  residentialType: ResidentialType
  isPrimary: boolean
  addressType: AddressType
  lat?: number
  lng?: number
  unitNo?: string
}

export interface ListAddressoResponseDto {
  items: CustomerAddressDto[]
  count: number
}

export interface UpdateCustomerAddressDto {
  accountId: string
  addressType: AddressType
  addressName: string
  addressLine1: string
  addressLine2?: string
  addressPostalCode: string
  addressCity?: string
  addressCountry?: string
  residentialType?: ResidentialType
  isPrimary: boolean
  unitNo?: string
}

export interface CustomerSubContact {
  countryCode: string
  contact: string
  id?: string
}

export enum DataRetentionEnum {
  OneMonth = 'ONE_MONTH',
  SixMonth = 'SIX_MONTHS',
  OneYear = 'ONE_YEAR',
  ThreeYear = 'THREE_YEARS',
  Fiveyear = 'FIVE_YEARS',
  Indefinite = 'INDEFINITE'
}

export enum DataRetentionLabel {
  OneMonth = '1 Month',
  SixMonth = '6 Months',
  OneYear = '1 Year',
  ThreeYear = '3 Years',
  Fiveyear = '5 Years',
  Indefinite = 'Indefinite'
}

export interface CustomerDataRetention {
  period: DataRetentionEnum
}

export interface ListReferralResponseDto {
  items: ReferralDto[]
  count: number
}

export interface ReferralDto {
  referred: {
    id: string
    email: string
    accountType: AccountType
    profile: ProfileDto
    employeeRoleId: string | null
    requestDeactiveDate: string | null
  }
  status: ReferralStatus
  createdAt: string
}

export enum ReferralStatus {
  Pending = 'pending',
  Completed = 'completed'
}

export interface PointLogsFilterQuery {
  offset?: number
  limit?: number
  search?: string
  all?: boolean
  sortBy?: string
  sortOrder?: 'DESC' | 'ASC'
}
export interface PointExtensionRequestFilterQuery {
  offset?: number
  limit?: number
  search?: string
  all?: boolean
  sortBy?: string
  accountId?: string
}
export interface PointLogDto {
  id: string
  point: number
  remainingPoint: number
  pointOperation: string
  status: string
  title: string
  referral: AccountInfoDto
  referred: {
    id: string
    email: string
    accountType: string
    socialLogin: any
    isActive: boolean
    profile: ProfileReffered
    employeeRoleId: any
    requestDeactiveDate: any
  }
  booking: BookingDto
  type: string
  expiresOn: string
  firstBookingDate: any
  bookingId: string
  accountId: string
  referredId: string
  referralId: string
  createdAt: string
  actionName: string
}
interface ProfileReffered {
  name: string
  contact: string
  countryCode: string
  avatarId: string
  avatarUrl: string
  firstName: string
  middleName: string
  lastName: string
  referralCode: string
  subContacts: any[]
}
export interface ListPointLogResponseDto {
  items: PointLogDto[]
  count: number
}
export interface PointExpiryExtensionRequestDto {
  id: string
  createdAt: string
  modifiedAt: string
  point: number
  reason: string
  status: ExpiryExtensionRequestStatus
  accountId: string
  code: number
  reasonReject: string
  newExpiryDate: string
  requestId: string
}
export enum ExpiryExtensionRequestStatus {
  Pending = 'Pending',
  Approved = 'Approved',
  Rejected = 'Rejected'
}
export interface ListExtensionRequestResponseDto {
  items: PointExpiryExtensionRequestDto[]
  count: number
}

export enum TimeUnitEnum {
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days',
  WEEKS = 'weeks',
  MONTHS = 'months'
}

export interface ReminderFrequencyItem {
  value: number | string
  timeUnit: TimeUnitEnum | string
}

export interface ServiceReminderFrequencyDto {
  setAsDefault: boolean
  reminds: ReminderFrequencyItem[]
}

export enum PointOperation {
  Add = 'Add',
  Minus = 'Minus'
}

export interface CustomerPointAndMembershipDto {
  currentPoint: number
}

export enum SortCustomerField {
  NAME = 'name',
  EMAIL = 'email',
  CONTACT = 'contact',
  CREATE_AT = 'createdAt',
  NO_OF_BOOKING = 'noOfBooking',
  SOCIAL_LOGIN = 'socialLogin',
  IS_BLACK_LIST = 'isBlackList',
}
